import React, { Component } from 'react';
import { Form, FormGroup, Col, FormControl, ControlLabel, Button, Modal } from 'react-bootstrap' 
import Fontawesome from 'react-fontawesome'
import AccountSettingsStore from 'stores/AccountSettingsStore'
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css"
import './Item.css'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {
      doc:{additional_text:'',address:'',attorney:'',branch:'',email:'',fax:'',name:'',tax_no:'',tel:'',bf_logo_width:128,bf_logo_height:90,bf_logo_url:undefined},
      showUp:false,
      src:null,
      crop:{
        unit:'%',
        width:30,
        aspect:16/9
      }
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()
  }

  // componentWillReceiveProps(newProps) {
  //   if (newProps.settings.show&&newProps.settings.show!==this.props.settings.show) {
  //     this.loadData()
  //   }
  // }

  loadData() {
    AccountSettingsStore.loadCompanyInfo((result)=>{
      let doc = result.data
      this.setState({doc:doc})
    })
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
    );

    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
            if (!blob) {
                return;
            }
            blob.name = fileName;
            window.URL.revokeObjectURL(this.fileUrl);
            this.fileUrl = window.URL.createObjectURL(blob);
            resolve(this.fileUrl);
        }, "image/jpeg");
    })
  }

  onSelectFile = e => {
      let {showUp} = this.state
      if (e.target.files && e.target.files.length > 0) {
          const reader = new FileReader();
          reader.addEventListener("load", () =>
              this.setState({ src: reader.result })
          );
          reader.readAsDataURL(e.target.files[0]);
      }
      if (!showUp) {
          setTimeout(()=>{
              this.setState({showUp:true})
          },100)
      }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = image => {
      this.imageRef = image;
  };

  onCropComplete = crop => {
      this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
      // You could also use percentCrop:
      // this.setState({ crop: percentCrop });
      this.setState({ crop });
  };

  async makeClientCrop(crop) {
      if (this.imageRef && crop.width && crop.height) {
          const croppedImageUrl = await this.getCroppedImg(
              this.imageRef,
              crop,
              "newFile.jpeg"
          );
          this.setState({ croppedImageUrl });
      }
  }

  onSaveClick() {
    let {doc} = this.state
    let {messages} = this.props
    AccountSettingsStore.saveCompanyInfo(doc,(result)=>{
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title:messages['Notice'],
          message:messages['Success Msg'],
          level:'info',
          position:'tc'
        });
      }  
    },()=>{
      this._notificationSystem.addNotification({
        title:messages['Notice'],
        message:messages['Error Msg'],
        level:'error',
        position:'tc'
      });  
    })    
  }

  onUploadClick() {
    let {croppedImageUrl,doc} = this.state
    doc.bf_logo_url = croppedImageUrl
    this.setState({doc:doc,showUp:false})
  }

  onDocChange(field,event) {
    let {doc} = this.state
    doc[field] = event.target.value
    this.setState({doc:doc})
  }

  renderFormButton() {
    let {messages} = this.props
    return(
      <div className='text-right'>
        <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><Fontawesome name='save' /> {messages['Save']}</Button>
      </div>
    )
  }

  renderForm() {
    let {doc} = this.state
    let {messages} = this.props
    return(
      <Form horizontal>
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={4}>
            {messages['Company Name']}
          </Col>
          <Col sm={8}>
            <FormControl value={doc.name} onChange={this.onDocChange.bind(this,'name')} />
          </Col>
        </FormGroup>
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={4}>
            {messages['Address']}
          </Col>
          <Col sm={8}>
            <FormControl 
              componentClass="textarea" 
              rows={3} 
              value={doc.address} 
              onChange={this.onDocChange.bind(this,'address')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={4}>
            {messages['Tax ID']}
          </Col>
          <Col sm={8}>
            <FormControl value={doc.tax_no} onChange={this.onDocChange.bind(this,'tax_no')}  />
          </Col>
        </FormGroup>
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={4}>
            {messages['Branch No']}
          </Col>
          <Col sm={8}>
            <FormControl value={doc.branch} onChange={this.onDocChange.bind(this,'branch')} />
          </Col>
        </FormGroup>
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={4}>
            {messages['Tel']}
          </Col>
          <Col sm={8}>
            <FormControl value={doc.tel} onChange={this.onDocChange.bind(this,'tel')} />
          </Col>
        </FormGroup>
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={4}>
            {messages['Fax']}
          </Col>
          <Col sm={8}>
            <FormControl value={doc.fax} onChange={this.onDocChange.bind(this,'fax')} />
          </Col>
        </FormGroup>
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={4}>
            {messages['Email']}
          </Col>
          <Col sm={8}>
            <FormControl value={doc.email} onChange={this.onDocChange.bind(this,'email')} />
          </Col>
        </FormGroup>
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={4}>
            {messages['Company Logo']}
          </Col>
          <Col sm={8}>
            <div className='box-img' style={{width:doc.bf_logo_width*1}}>
              {doc.bf_logo_url?<img alt="LOGO" style={{maxWidth:"100%"}} src={doc.bf_logo_url} />:<Fontawesome name='picture-o' />}
            </div>
            <div className='btn-select-img'>
              <div className='btn btn-md btn-primary'>
                <Fontawesome name='picture-o' /> {messages['Select Logo']}
                <input type="file" onChange={this.onSelectFile} />
              </div>
            </div>
          </Col>
        </FormGroup>
      </Form>  
    )
  }

  renderUploadModal() {
    let { showUp, crop, croppedImageUrl, src } = this.state
    let {messages} = this.props
    return(
          <Modal show={showUp} onHide={()=>{this.setState({showUp:false})}} dialogClassName="midwidth-dialog">
            <Modal.Header closeButton>
                <Modal.Title>{messages['Upload IMG']}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className='account-settings-menu-0'>
                <div className='btn-select-img'>
                    <div className='btn btn-md btn-primary'>
                        <Fontawesome name='picture-o' /> {messages['Select Logo']}
                        <input type="file" onChange={this.onSelectFile} />
                    </div>
                </div>
                {croppedImageUrl?
                <div className='text-center'>
                  {messages['Example Picture']}
                </div>    
                :''}
                <div className='text-center'>
                    {croppedImageUrl && (
                        <img alt="Crop" style={{width:'180px'}} src={croppedImageUrl} />
                    )}
                </div>
                <br />
                <div className='text-center'>
                    {src && (
                    <ReactCrop
                        src={src}
                        crop={crop}
                        onImageLoaded={this.onImageLoaded}
                        onComplete={this.onCropComplete}
                        onChange={this.onCropChange}
                    />
                    )}
                </div>   
              </div>  
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={this.onUploadClick.bind(this)}><Fontawesome name='save' />&nbsp;{messages['Save']}</Button>
                <Button onClick={()=>{this.setState({showUp:false})}}><Fontawesome name='close' />&nbsp;{messages['Close']}</Button>
            </Modal.Footer>
          </Modal>
    )
  }

  render() {
    let {messages} = this.props
    return(
  		<div className='account-settings-menu-0' style={{maxWidth:'680px'}}>
        <h3>{messages['Company Info']}</h3>
        {this.renderForm()}
        {this.renderFormButton()}
        {this.renderUploadModal()}
        <NotificationSystem ref="notificationSystem" />
  		</div>
  	)
  }

}
 
// export default Item;
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu0.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu0/Item.js